var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
export class Me {
    get fullname() {
        return `${this.first_name} ${this.last_name}`;
    }
}
__decorate([
    Type(() => Profile)
], Me.prototype, "profile", void 0);
__decorate([
    Type(() => AuthToken)
], Me.prototype, "auth_token", void 0);
export class Profile {
}
__decorate([
    Type(() => Permissions)
], Profile.prototype, "permissions", void 0);
export class Permissions {
}
export class AuthToken {
}
